import * as DisclaimerStyles from './Disclaimer.css';
export default {
    DisclaimerStyles
};
